/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
export { downgradeComponent } from './src/aot/downgrade_component';
export { downgradeInjectable } from './src/aot/downgrade_injectable';
export { UpgradeComponent } from './src/aot/upgrade_component';
export { UpgradeModule } from './src/aot/upgrade_module';
//# sourceMappingURL=static.js.map


// WEBPACK FOOTER //
// ./~/@angular/upgrade/static.js